import {
  APP_INITIALIZER,
  enableProdMode,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/auth/auth.interceptor';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { provideServiceWorker } from '@angular/service-worker';
import { ConfigurationService } from './app/_shared/services/configuration.service';

function initializeApp(
  configService: ConfigurationService
): () => Promise<unknown> {
  return () => configService.load();
}

if (environment.production) {
  enableProdMode();
}

const config: SocketIoConfig = {
  url: environment.SOCKET_URL,
  options: {
    reconnection: true,
    reconnectionDelay: 5000,
    reconnectionDelayMax: 15000,
    reconnectionAttempts: 5,
    path: environment.SOCKET_PATH,
    transports: ['websocket'],
  },
};

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigurationService],
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(SocketIoModule.forRoot(config)),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
});
